import { RelayFieldLogger } from "relay-runtime";
import { logger } from "./logger";

export interface EnvironmentOptions {
  userId?: string;
}

export const relayFieldLogger: RelayFieldLogger | undefined | null = (
  event,
) => {
  switch (event.kind) {
    case "missing_expected_data.log":
      // Data expected to be in the store was missing (e.g. a fragment
      // read before its query finished). Usually transient.
      logger.warn(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
        },
        "[relay] missing expected data",
      );
      break;

    case "missing_expected_data.throw":
      // Same as above, but Relay is about to throw / suspend.
      logger.warn(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
          handled: event.handled,
        },
        "[relay] missing expected data (throw)",
      );
      break;

    case "missing_required_field.log":
      // @required(action: LOG) field was null.
      logger.warn(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
        },
        "[relay] missing @required field",
      );
      break;

    case "missing_required_field.throw":
      // @required(action: THROW) field was null.
      logger.error(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
          handled: event.handled,
        },
        "[relay] missing @required field (throw)",
      );
      break;

    case "relay_resolver.error":
      // A Relay Resolver threw while computing its value.
      logger.error(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
          error: event.error,
          handled: event.handled,
        },
        "[relay] resolver error",
      );
      break;

    case "relay_field_payload.error":
      // The server returned a field-level error in the GraphQL payload.
      logger.error(
        {
          owner: event.owner,
          fieldPath: event.fieldPath,
          error: event.error,
          handled: event.handled,
        },
        "[relay] field payload error",
      );
      break;

    default: {
      const _exhaustive: never = event;
      logger.warn("[relay] unknown field logger event", _exhaustive);
    }
  }
};
